const LOGOS = {
  ECOCERT: {
    src: 'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/raloaheg_IMG_7105.png',
    label: 'ECOCERT',
    sub: 'Certified organic',
  },
  BioSPG: {
    src: 'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/742121ff_IMG_7106.png',
    label: 'BioSPG',
    sub: 'CNABio · Burkina Faso',
  },
  CNABio: {
    src: 'https://customer-assets.emergentagent.com/job_climate-resilience-5/artifacts/gi9jclvj_IMG_7104.png',
    label: 'CNABio',
    sub: 'Membre officiel',
  },
};

export default function CertBadge({ name, size = 96, withLabel = false }) {
  const logo = LOGOS[name];
  if (!logo) return null;
  return (
    <div className="inline-flex items-center gap-3" data-testid={`cert-badge-${name.toLowerCase()}`}>
      <div
        className="grid place-items-center bg-white rounded-full shadow-sm shrink-0 overflow-hidden border border-border-soft"
        style={{ width: size, height: size }}
      >
        <img
          src={logo.src}
          alt={`${name} certification`}
          className="object-contain"
          style={{ width: size * 0.84, height: size * 0.84 }}
          loading="lazy"
        />
      </div>
      {withLabel && (
        <div className="leading-tight">
          <p className="font-heading text-lg text-ink">{logo.label}</p>
          <p className="text-xs uppercase tracking-widest text-ink-muted">{logo.sub}</p>
        </div>
      )}
    </div>
  );
}
